module.exports = __webpack_public_path__ + "assets/img/shrink.a65c3ef3.svg";